import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type';
import { fetchApi } from '@/config/axiosSetting';

export const countryRequest = (
  name: string,
): Promise<PaginationResponseType<{ id: number; name: string }[]>> => {
  return fetchApi({
    method: 'GET',
    url: 'selection_item/country/list/',
    params: {
      type: 'list',
      name: name || null,
    },
  });
};
